module.exports = __webpack_public_path__ + "fonts/NeutraTextBook.cf9277dc.otf";